// import axios from 'axios'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
// Import vue stuff
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Register from '@/views/Register.vue'
import Login from '@/views/Login'
import Moving from '@/views/Moving'
import ResetPassword from '@/views/ResetPassword'
import Privacy from '@/views/Privacy'
import Terms from '@/views/Terms'
import NotFound from '@/views/404.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/moving',
      name: 'Moving',
      component: Moving
    },
    {
      path: '/resetpassword',
      name: 'Reset Password',
      component: ResetPassword
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/decisions',
      name: 'Decisions',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Decisions.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/discover',
      name: 'Discover',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Discover.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/decisions/:decisionId',
      name: 'Decision',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Decision.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  // Require verified users
  // TODO implement email verification
  // if (requiresAuth && (!currentUser || !currentUser.emailVerified)) {
  if (requiresAuth) {
    // const forwardPath = window.location.pathname
    // next({ name: 'Login', query: { from: forwardPath, failedVerification: (currentUser ? !currentUser.emailVerified : false) } })

    if (currentUser && currentUser.emailVerified) {
      // Initialize user store if not already
      if (!router.app.$store.state.user.loaded) {
        router.app.$store.dispatch('user/loadPreferences').then(prefs => {
        if (prefs && !prefs.isAdmin) {
          // For now redirect to moving unless it is the admin
          router.replace('/moving')
        }
      })
      }
      next()
    } else  {
      const forwardPath = window.location.pathname
      next({ name: 'Login', query: { from: forwardPath, failedVerification: (currentUser ? !currentUser.emailVerified : false) } })
    }
  } else {
    next()
  }
})

export default router
